import DoAPICall from './DoAPICall'

//Create Aggregated Client
    export async function createAggregatedClient(userToken, aggregatedclient){
        const apiPayload = {
            httpMethod:'post',
            userToken,
            uri:'aggregatedclients',
            payLoad:{
                parent_id:aggregatedclient.parent_id,
                client_id:aggregatedclient.client_id,
                menuNo:aggregatedclient.menuNo
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get All Aggregated Client
    export async function getAggregatedClients(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'aggregatedclients',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get One Aggregated Client
    export async function getAggregatedClient(userToken, id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'aggregatedclients/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get Payments Providers of client
export async function getClientsOfAggregator(userToken,parent_id){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'clientsofaggregator/'+parent_id,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Update Aggregated Client
    export async function updateAggregatedClient(userToken, aggregatedclient){
        const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'aggregatedclients/'+aggregatedclient.id,
            payLoad:{
                menuNo:aggregatedclient.menuNo
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Delete Aggregated Client
    export async function deleteAggregatedClient(userToken, id){
        const apiPayload = {
            httpMethod:'delete',
            userToken,
            uri:'aggregatedclients/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }
